var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightModeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2H13.5V5H10.5V2ZM16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8C13.0609 8 14.0783 8.42143 14.8284 9.17157C15.5786 9.92172 16 10.9391 16 12ZM5.99 3.869L3.867 5.99L5.99 8.112L8.111 5.99L5.989 3.87L5.99 3.869ZM2 13.5V10.5H5V13.5H2ZM3.868 18.01L5.989 20.13L8.111 18.01L5.989 15.888L3.868 18.01ZM13.5 19V22H10.5V19H13.5ZM18.01 15.888L15.889 18.01L18.01 20.131L20.131 18.01L18.01 15.888ZM19 10.5H22V13.5H19V10.5ZM15.89 5.99L18.01 8.111L20.132 5.99L18.011 3.869L15.889 5.99H15.89Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeLight);
export default __webpack_public_path__ + "static/media/light_modeLight.8c5a5f1086365ad54ac0d41330abfc54.svg";
export { ForwardRef as ReactComponent };